import { render } from "./AddArgumentsModal.vue?vue&type=template&id=3baa526f"
import script from "./AddArgumentsModal.vue?vue&type=script&lang=js"
export * from "./AddArgumentsModal.vue?vue&type=script&lang=js"

import "./AddArgumentsModal.vue?vue&type=style&index=0&id=3baa526f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__